"use client";

import { RiDiscordLine, RiMailLine } from "@remixicon/react";
import { Button } from "@workspace/ui/components/button";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@workspace/ui/components/card";
import { useCallback } from "react";
import { SupportModal } from "@/components/feedback/support-modal";
import { useSupportModal } from "@/lib/utils/ui/support";

export function SupportClient() {
	const { isOpen, feedbackType, openSupportModal, closeSupportModal } =
		useSupportModal();

	const handleContactSupport = useCallback(() => {
		openSupportModal();
	}, [openSupportModal]);

	return (
		<>
			<div className="grid gap-4 md:grid-cols-2">
				{/* Contact Support Card */}
				<Card className="border-2 border-muted">
					<CardHeader className="pb-4">
						<div className="flex items-center gap-3">
							<div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
								<RiMailLine className="h-5 w-5 text-primary" />
							</div>
							<div>
								<CardTitle className="text-lg">Contact Support</CardTitle>
								<CardDescription className="text-sm">
									Get help from our team
								</CardDescription>
							</div>
						</div>
					</CardHeader>
					<CardContent className="pt-0">
						<p className="mb-4 text-muted-foreground text-sm">
							Report issues, ask questions, or request features. We'll get back
							to you as soon as possible.
						</p>
						<Button onClick={handleContactSupport} className="w-full">
							Contact Support
						</Button>
					</CardContent>
				</Card>

				{/* Join Discord Card */}
				<Card className="border-2 border-muted">
					<CardHeader className="pb-4">
						<div className="flex items-center gap-3">
							<div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
								<RiDiscordLine className="h-5 w-5 text-primary" />
							</div>
							<div>
								<CardTitle className="text-lg">Join Discord</CardTitle>
								<CardDescription className="text-sm">
									Connect with the community
								</CardDescription>
							</div>
						</div>
					</CardHeader>
					<CardContent className="pt-0">
						<p className="mb-4 text-muted-foreground text-sm">
							Join our Discord server to chat with other users, get updates, and
							share feedback.
						</p>
						<a
							href="https://discord.gg/BWCeC5jVQt"
							target="_blank"
							rel="noopener noreferrer"
							className="block"
						>
							<Button variant="outline" className="w-full">
								Join Discord
							</Button>
						</a>
					</CardContent>
				</Card>
			</div>

			<SupportModal
				isOpen={isOpen}
				onClose={closeSupportModal}
				initialType={feedbackType}
			/>
		</>
	);
}
